/* v6.6 a11y: Flickity (and Swiper) mark off-screen cells aria-hidden="true"
   but leave the links inside focusable, tripping the aria-hidden-focus audit
   and letting keyboard users tab into invisible slides. Mirror aria-hidden
   into the `inert` attribute so hidden cells drop out of the tab order and
   the accessibility tree together. Engine-agnostic: one observer per
   carousel container, attribute-scoped, no per-frame work. */
(function () {
  function sync(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    if (hidden) { cell.setAttribute('inert', ''); }
    else { cell.removeAttribute('inert'); }
  }
  function watch(container) {
    if (container.__gvInert) { return; }
    container.__gvInert = true;
    container.querySelectorAll('[aria-hidden]').forEach(sync);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'attributes' && m.target.nodeType === 1) { sync(m.target); }
      });
    }).observe(container, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  }
  function scan() {
    document.querySelectorAll('.flickity-enabled, .swiper').forEach(watch);
  }
  // carousels initialize after their engines load; a light settle loop
  // catches late initializers without a permanent body-wide observer
  var tries = 0;
  var t = setInterval(function () {
    scan();
    if (++tries >= 10) { clearInterval(t); }
  }, 1000);
  if (document.readyState !== 'loading') { scan(); }
  else { document.addEventListener('DOMContentLoaded', scan); }
})();
